var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "counters-wrapper" }, [
    _setup.ListStatus.OK !== _setup.status
      ? _c(
          "div",
          { staticClass: "counters" },
          _vm._l(_setup.loadingData, function (counter, index) {
            return counter.hasPermission
              ? _c(_setup.LfWhiteCounterComponent, {
                  key: `loading-counter-${index}`,
                  attrs: { info: counter, showSpinner: true },
                })
              : _vm._e()
          }),
          1
        )
      : _c(
          "div",
          { staticClass: "counters" },
          _vm._l(_setup.widgetList, function (counter, index) {
            return counter.hasPermission
              ? _c(_setup.LfWhiteCounterComponent, {
                  key: `counter-${index}`,
                  attrs: { info: counter },
                })
              : _vm._e()
          }),
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }